import { css } from 'emotion';

import { fonts } from '../styles';

export const content = css`
  position: relative;

  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: column;

  padding: 50px 20px 20px;
`;

export const close = css`
  && {
    position: absolute;
    top: 20px;
    right: 20px;
  }
`;

export const reportIcon = css`
  width: 90px;
  height: 100px;
`;

export const title = css`
  margin-top: 30px;
  line-height: 24px;
`;

export const text = css`
  margin: 20px 0 0;
  line-height: 19px;
`;

export const email = css`
  font-weight: ${fonts.weight.bold};
`;

export const confirm = css`
  && {
    margin-top: 20px;
    line-height: 16px;
  }
`;
